<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Importar dados"
            description=""
            url="/administracao"
            :enabledModalInformacao="false"
            :enabledIframeModalInformacao="false"
            urlIframeModalInformacao=""
            pageIdentifier="administracao-importar-dados"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw
                  ?.administracao_importar_dados_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.administracao_importar_dados_ajuda ||
              0
            "
            keyAjudaModalInformacao="administracao_importar_dados_ajuda"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <div
                class="ribbon"
                v-if="item.featured !== undefined && item.featured == true"
              >
                <span>BETA</span>
              </div>

              <span
                v-if="$store.getters.getQuantidadeAjuda(item.key) > 0"
                class="item-badge"
              >
                {{ $store.getters.getQuantidadeAjuda(item.key) }}
              </span>

              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img
                v-else-if="item.imagem !== ''"
                :src="item.imagem !== '' ? item.imagem : ''"
                alt=""
              />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'ImportarDadosIndex',
  metaInfo: {
    title: 'Importar dados',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.administracao_importar_dados
      ) {
        const dataClone = [
          ...this.$store.state.permissoes.administracao_importar_dados,
        ]
        return dataClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
